import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const costs = ['Des heures perdues à chercher de nouveaux exercices.', 'Des cours qui finissent par utiliser les mêmes combinaisons.', 'Des progressions difficiles à organiser sur plusieurs semaines.', 'Des corrections techniques improvisées au dernier moment.', 'Des groupes de niveaux différents plus difficiles à gérer.', 'Des élèves dont la progression est difficile à suivre.', 'Des soirées et des week-ends consacrés à préparer vos prochains cours.', 'Et cette sensation permanente de devoir encore préparer quelque chose avant d’entrer en studio.'];
export function PainPoints() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-28" data-id="element-171" data-mp="1sy4y27g0pixs">
      <div className="mx-auto max-w-3xl" data-id="element-172" data-mp="1t0r8ceuamcjp">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center" data-id="element-173" data-mp="3idbgfx12otgx">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-deep" data-id="element-174" data-mp="1yykdfd6qx80p">
            Un soir comme tant d’autres…
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-brand-ink sm:text-4xl" data-id="element-175" data-mp="27t8k97ryyxrm">
            Cette situation vous semble familière ?
          </h2>
          <div className="mt-7 rounded-xl border border-brand-line bg-white p-6 text-left text-base leading-7 text-brand-muted shadow-card sm:p-8" data-id="element-176" data-mp="23thvf9m06rpq">
            <p data-id="element-177" data-mp="1b3hqjari5emv">Il est tard.</p>
            <p className="mt-4" data-id="element-178" data-mp="1b4anxl4kmrsc">Vous avez un cours de danse classique le lendemain.</p>
            <p className="mt-4" data-id="element-179" data-mp="1p3aa8m4m2ulc">
              Et vous êtes encore en train de chercher des exercices, de
              réfléchir à votre barre, de construire le travail au centre ou
              d’essayer de trouver une progression adaptée au niveau de vos
              élèves.
            </p>
            <p className="mt-4" data-id="element-180" data-mp="2vhrq7gnjqygj">
              <strong className="font-semibold text-brand-ink" data-id="element-181" data-mp="2vknox777xr61">
                Pas parce que vous ne connaissez pas la danse classique. Vous la
                connaissez.
              </strong>
            </p>
            <p className="mt-4" data-id="element-182" data-mp="1y62p0a6qd7sp">
              Mais parce que vous devez encore construire une grande partie de
              vos cours à partir de zéro.
            </p>
            <p className="mt-4 font-medium text-brand-ink" data-id="element-183" data-mp="2744zrhg9net6">
              Vous cherchez. Vous adaptez. Vous organisez. Vous modifiez.
            </p>
            <p className="mt-4" data-id="element-184" data-mp="1efr06x9j4afi">Puis vous recommencez la semaine suivante.</p>
            <p className="mt-4" data-id="element-185" data-mp="1jfbzx9wiwmta">
              Et les heures que vous pourriez consacrer à vous reposer ou à
              votre vie personnelle finissent encore une fois dans la
              préparation de vos prochaines séances.
            </p>
          </div>
        </motion.div>

        <div className="mt-14" data-id="element-186" data-mp="qolkci3l9i57">
          <h3 className="text-center text-xl font-semibold text-brand-ink" data-id="element-187" data-mp="vphlinwk2q6x">
            Le véritable coût de ne pas avoir le bon système
          </h3>
          <ul className="mt-7 space-y-3" data-id="element-188" data-mp="o5gtekfjwo90">
            {costs.map((cost, index) => <motion.li key={cost} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04
          }} className="flex items-start gap-3 rounded-lg border border-brand-rose/40 bg-brand-blush px-5 py-4 text-sm leading-6 text-brand-muted" data-id="element-189" data-mp="j7oqywha5jqk" data-mpi={index}>
                <XIcon size={17} className="mt-0.5 shrink-0 text-brand-deep" aria-hidden="true" data-id="element-190" data-mp="eulct5jr3z0" />
                {cost}
              </motion.li>)}
          </ul>
          <div className="mt-12 border-t border-brand-gold/40 pt-8 text-center" data-id="element-191" data-mp="3imk2appfshng">
            <p className="font-display text-2xl font-semibold text-brand-ink sm:text-3xl" data-id="element-192" data-mp="3dnfpzq77u3sw">
              Votre expérience est déjà là. Ce qu’il vous faut maintenant, c’est
              un système qui organise le travail pour vous.
            </p>
            <p className="mt-3 text-lg font-semibold text-brand-deep" data-id="element-193" data-mp="1ll4o18d75adv">
              Organisez votre année de danse classique dès aujourd’hui.
            </p>
          </div>
        </div>
      </div>
    </section>;
}